export default "__VITE_ASSET__CMLwplZR__"